export const startsWithUppercase = (string: string) => string[0] !== string[0].toLowerCase()
export const hasWhiteSpace = (string: string) => /\s/.test(string)
